// src/api/conversationsApi.js
import axiosClient from './axiosClient';

export const createConversation = async (payload) => {
  // POST a new conversation record.
  // console.log(payload);
  const response = await axiosClient.post('/conversations', payload);
  return response.data;
};

export const updateConversation = async (chatId, payload) => {
  // PATCH the existing conversation record.
  // console.log(chatId, payload);
  const response = await axiosClient.patch(`/conversations/${chatId}`, payload);
  return response.data;
};
